import api from './index';

const searchShipment = (status, date, bol, phone, name, destination) => api.get('/shipment/search', {
  params: {
    ...Object.fromEntries(Object.entries({
      status,
      date,
      // 'shipment-id': shipmentId,
      bol,
      phone,
      name,
      destination,
    }).filter((kv) => !!kv[1])),
  },
});

const searchManifest = (date, bol, departure, destination) => api.get('/manifest/search', {
  params: {
    ...Object.fromEntries(Object.entries({
      date,
      bol,
      departure,
      destination,
    }).filter((kv) => !!kv[1])),
  },
});

// const delayedShipment = () => api.get('/delayedShipment');

const delayedShipment = () => api.get('/delayedShipment');

const unpaidShipment = () => api.get('/unpaidShipment');

// eslint-disable-next-line import/prefer-default-export
export {
  searchShipment, delayedShipment, unpaidShipment, searchManifest,
};
